import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPlaces } from "./places";

const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (id, { dispatch }) => {
    const places = await dispatch(fetchPlaces());

    const response = await axios.get(
      `https://qr.me-menu.com/app/order/get/only-categories/by/place/${places.payload.id}`
    );
    return response.data.data.categories;
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    list: [],
  },
  reducer: {},
  extraReducers: {
    [fetchCategories.fulfilled]: (state, action) => {
      state.list = action.payload;
    },
  },
});

export default categoriesSlice.reducer;
export { fetchCategories };
